export enum GlobalIcon {
  Actions = '/assets/images/global-icons/actions.svg',
  AngleDown = '/assets/images/global-icons/angle-down.svg',
  ArrowStraightRight = '/assets/images/global-icons/arrow-straight-right.svg',
  ArrowRight = '/assets/images/global-icons/arrow-right.svg',
  ArrowDownRight = '/assets/images/global-icons/arrow-down-right.svg', //TODO: replace with svg w transparent bg like the others
  ArrowRightSmall = '/assets/images/global-icons/arrow-right-small.svg',
  ArrowUpRight = '/assets/images/global-icons/arrow-up-right.svg',
  ArrowHideToLeft = '/assets/images/global-icons/arrow-hide-to-left.svg',
  ArrowHideToRight = '/assets/images/global-icons/arrow-hide-to-right.svg',
  Bars = '/assets/images/global-icons/bars.svg',
  Bell = '/assets/images/global-icons/bell.svg',
  Check = '/assets/images/global-icons/check.svg',
  CheckCircle = '/assets/images/global-icons/check-circle.svg',
  CheckmarkFilledCircle = '/assets/images/global-icons/checkmark-filled-circle.svg',
  ChevronDown = '/assets/images/global-icons/chevron-down.svg',
  ChevronDownMedium = '/assets/images/global-icons/chevron-down-medium.svg',
  ChevronLeft = '/assets/images/global-icons/chevron-left.svg',
  ChevronLeftSmall = '/assets/images/global-icons/chevron-left-small.svg',
  ChevronRight = '/assets/images/global-icons/chevron-right.svg',
  ChevronRightSmall = '/assets/images/global-icons/chevron-right-small.svg',
  ChevronRightMedium = '/assets/images/global-icons/chevron-right-medium.svg',
  ChevronSolidDown = '/assets/images/global-icons/chevron-solid-down.svg',
  ChevronUp = '/assets/images/global-icons/chevron-up.svg',
  Cog = '/assets/images/global-icons/cog.svg',
  Copy = '/assets/images/global-icons/copy.svg',
  Download = '/assets/images/global-icons/download.svg',
  EllipsisHorizontalLarge = '/assets/images/global-icons/ellipsis-horizontal-large.svg',
  EyeSlash = '/assets/images/global-icons/eye-slash.svg',
  Emissions = '/assets/images/global-icons/emissions.svg',
  ExternalLink = '/assets/images/global-icons/external-link.svg',
  ExclamationPoint = '/assets/images/global-icons/exclamation-point.svg',
  Filter = '/assets/images/global-icons/filter.svg',
  GroupWhite = '/assets/images/global-icons/group.white.svg',
  InfoCircle = '/assets/images/global-icons/info-circle.svg',
  InternalLink = '/assets/images/global-icons/internal-link.svg',
  Mail = '/assets/images/global-icons/mail.svg',
  MaximizeMedium = '/assets/images/global-icons/maximize-medium.svg',
  MinimizeMedium = '/assets/images/global-icons/minimize-medium.svg',
  MinusCircle = '/assets/images/global-icons/minus-circle.svg',
  Pencil = '/assets/images/global-icons/pencil.svg',
  Plus = '/assets/images/global-icons/plus.svg',
  PlusCircle = '/assets/images/global-icons/plus-circle.svg',
  PercentageWheel = '/assets/images/global-icons/percentage-wheel-dupe.svg',
  QuestionCircle = '/assets/images/global-icons/question-circle.svg',
  WarningTriangle = '/assets/images/global-icons/warning-triangle.svg',
  SortWhite = '/assets/images/global-icons/sort.white.svg',
  Target = '/assets/images/global-icons/target.svg',
  Tenant = '/assets/images/global-icons/tenant.svg',
  Trashcan = '/assets/images/global-icons/trashcan.svg',
  TransitionElement = '/assets/images/global-icons/transition-element.svg',
  Upload = '/assets/images/global-icons/upload.svg',
  User = '/assets/images/global-icons/user.svg',
  UserCircle = '/assets/images/global-icons/user-circle.svg',
  X = '/assets/images/global-icons/x.svg',
  XCircle = '/assets/images/global-icons/x-circle.svg',
}

export enum GlobalIconColour {
  CheckTeal = '#408578',
  Dark = '#0B0d0E',
  Grey = '#73808c',
  LinkBlue = '#3395cc',
  PrimaryDashboard100 = '#d4dfeb',
  PrimaryDashboard300 = '#8695a5',
  PrimaryDashboard400 = '#667688',
  Transparent = 'transparent',
  WarningRed = '#cc3349',
  White = '#ffffff',
  WhiteDashboard = '#F8FBFF',
  NegativeRed = '#E08084',
  PositiveGreen = '#7CC99F',
}

export enum GlobalIconSize {
  Xs = 10,
  Small = 12,
  Medium = 14,
  Large = 18,
  Xl = 22,
  Xxl = 48,
}
